import locations from "./locations";
import courses from "./courses";
import teachers from "./teachers";
import disciplines from "./disciplines";
import students from "./students";
import purchases from "./purchases";
import logs from "./logs";
import trash from "./trash";

export default [
  locations,
  courses,
  teachers,
  disciplines,
  students,
  purchases,
  logs,
  trash,
];
